import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { documentToHtmlString } from "@contentful/rich-text-html-renderer";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { IconName } from "@fortawesome/free-brands-svg-icons";
import { TypeTileTextFields } from "../../../models/contentful-content-types/tile-text";
import { AssetFile } from "contentful";
import { ButtonComponent } from "../button/button.component";

@Component({
  imports: [CommonModule, FontAwesomeModule, ButtonComponent],
  selector: "jnguyen-tile-text",
  templateUrl: "./tile-text.component.html",
  styleUrls: ["./tile-text.component.scss"],
})
export class TileTextComponent {
  @Input() tile: TypeTileTextFields;
  documentToHtmlString = documentToHtmlString;

  getIcon(icon: IconName, iconClass: string): string[] {
    return [iconClass, icon];
  }
  getImageUrl(url: string | AssetFile) {
    if (typeof url === "string") {
      const cutUrl = url.replace(/\/\/images\.ctfassets\.net\//, "");
      return `${cutUrl}`;
    }
  }
}
